const carouselItems = [
  {
    title: '97视频：老牌平台的坚守与创新',
    desc: '作为在线视频领域的老牌力量，97视频凭借稳定的内容更新节奏和广泛的用户基础，持续占据市场重要份额。本期专题深度分析其会员体系变化与独家内容策略。',
    tag: '深度测评',
    isLarge: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20amber%20and%20deep%20crimson%20gradients%2C%20luxurious%20theater%20curtain%20texture%2C%20dramatic%20spotlight%20effect%2C%20premium%20entertainment%20atmosphere&width=1200&height=600&seq=carousel-97&orientation=landscape',
  },
  {
    title: '丝瓜视频：新生代用户的首选？',
    desc: '丝瓜视频近年来凭借简洁的界面设计和精准的内容推荐算法，吸引了大量年轻用户群体。我们拆解其产品逻辑，看看它为何能快速崛起。',
    tag: '平台解析',
    isLarge: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20interface%20with%20soft%20green%20and%20warm%20beige%20gradients%2C%20clean%20geometric%20layout%2C%20fresh%20contemporary%20design%20aesthetic%2C%20subtle%20glass%20morphism%20effect&width=800&height=500&seq=carousel-sigua&orientation=landscape',
  },
  {
    title: '蓝莓视频：独家内容库的秘密',
    desc: '蓝莓视频的内容差异化策略令人瞩目，其独家内容库覆盖多个热门分类。本期走进蓝莓视频的内容生态，揭示其吸引用户持续回归的核心竞争力。',
    tag: '内容解析',
    isLarge: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20deep%20indigo%20and%20warm%20amber%20abstract%20gradient%2C%20flowing%20organic%20shapes%2C%20luxurious%20velvet%20texture%2C%20mysterious%20cinematic%20mood%20lighting&width=800&height=500&seq=carousel-lanmei&orientation=landscape',
  },
  {
    title: '91在线视频：稳定访问指南',
    desc: '对于追求稳定观影体验的用户来说，91在线视频的访问稳定性一直是核心关注点。我们整理了最新的访问方式和优化建议，助你畅享流畅观影。',
    tag: '实用指南',
    isLarge: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Sleek%20dark%20interface%20with%20warm%20orange%20accent%20highlights%2C%20modern%20tech%20texture%2C%20clean%20minimalist%20digital%20dashboard%20concept%2C%20professional%20streaming%20platform%20feel&width=800&height=500&seq=carousel-91&orientation=landscape',
  },
  {
    title: '糖心视频 × 黑桃视频：双子星对谈',
    desc: '糖心视频与黑桃视频作为热门在线视频平台中的后起之秀，各自走出了不同的发展路径。本期横向对比两大平台，帮你理清选择思路。',
    tag: '横向对比',
    isLarge: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dual%20tone%20abstract%20composition%20with%20warm%20pink%20and%20dark%20charcoal%20gradients%2C%20geometric%20split%20design%2C%20modern%20brand%20comparison%20visual%2C%20clean%20editorial%20style&width=800&height=500&seq=carousel-tangxin&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            焦点推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            焦点专题推荐
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            精选在线视频平台深度专题，帮你全面了解各平台特色
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl border border-background-200/60 overflow-hidden flex flex-col ${
                item.isLarge ? 'lg:col-span-3 lg:flex-row' : ''
              }`}
            >
              <div className={`relative ${item.isLarge ? 'lg:w-1/2' : 'w-full'} aspect-[16/10]`}>
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded-full bg-background-50/90 text-foreground-700 text-[10px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className={`p-5 flex flex-col justify-center ${item.isLarge ? 'lg:w-1/2' : ''}`}>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}